<template>
    <form action="" class="schedule-send-modal">
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
                <p class="modal-card-title">Schedule send</p>
                <o-button
                    class="close"
                    rounded
                    size="is-small"
                   @click="$parent.$parent.$emit('update:active', false)"
                >
                    <o-icon icon="close" pack="mdi"></o-icon>
                </o-button>
            </header>
            <section class="modal-card-body">
                <div class="timezone">
                    <span>{{ timezone }}</span>
                </div>
                <div class="menu">
                    <ul>
                        <li
                            class="date"
                            v-for="(item, key) in data"
                            :key="key"
                            @click="handle_select_date(item)"
                        >
                            <span>{{ item.label }}</span>
                            <span>{{ item.date_label }}</span>
                        </li>
                    </ul>
                </div>
            </section>
            <footer class="modal-card-foot">
                <div class="menu">
                    <ul>
                        <li @click="handle_datetime">
                            <o-icon icon="calendar" pack="mdi" />
                            <div>Pick date & time</div>
                        </li>
                    </ul>
                </div>
            </footer>
        </div>
    </form>
</template>

<script>
export default {
    computed: {
        timezone() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone
        },
    },
    data() {
        return {
            data: [],
        }
    },
    methods: {
        handle_datetime(e) {
            this.$emit('pick_datetime', e)
        },
        handle_select_date(item) {
            this.$emit('send_scheduled', item.date.format('YYYY-MM-DD HH:mm:ss'))
        }
    },
    mounted() {
        const now = new Date(),
            format = 'MMM D, LT'
        let today = moment(now)
        today.set('hour', 8)
        today.set('minute', 0)
        today.set('second', 0)

        const tomorrow_morning = today.clone().add(1, 'days')
        today.set('hour', 13)
        const tomorrow_afternoon = today.clone().add(1, 'days')
        this.data = []
        this.data.push({
            id: 'tomorrow_morning',
            date: tomorrow_morning,
            date_label: tomorrow_morning.format(format),
            label: 'Tomorrow morning',
        })
        this.data.push({
            id: 'tomorrow_afternoon',
            date: tomorrow_afternoon,
            date_label: tomorrow_afternoon.format(format),
            label: 'Tomorrow afternoon',
        })
    },
}
</script>

<style>
.schedule-send-modal .modal-card-head {
  background: #fff;
  border: none;
  padding-bottom: 8px;
  padding: 20px 16px 8px 20px; }
.schedule-send-modal .modal-card-head .modal-card-title {
  font-size: 22px; }
.schedule-send-modal .modal-card-head .close {
  background: transparent;
  border: none;
  border-radius: 50%;
  box-shadow: none;
  font-size: 17px;
  height: 40px;
  width: 40px; }
.schedule-send-modal .modal-card-head .close:hover {
  background: #000017; }

.schedule-send-modal .modal-card-body {
  padding: 0; }
.schedule-send-modal .modal-card-body .timezone {
  margin: 0 0 16px 24px; }

.schedule-send-modal .modal-card-foot {
  background-color: #fff;
  padding: 0; }

.schedule-send-modal div.menu {
  width: 100%; }
.schedule-send-modal div.menu ul {
  list-style: none; }
.schedule-send-modal div.menu ul li {
  display: flex;
  color: black;
  padding: 8px 24px;
  user-select: none;
  width: 100%; }
.schedule-send-modal div.menu ul li > span:first-child {
  color: #3c4043;
  margin-right: 40px; }
.schedule-send-modal div.menu ul li > span:last-child {
  color: #5f6368;
  margin-left: auto; }
.schedule-send-modal div.menu ul li:hover {
  cursor: pointer;
  background-color: rgba(60, 64, 67, 0.04); }
.schedule-send-modal div.menu ul li > div, .schedule-send-modal div.menu ul li > span {
  line-height: 36px; }
.schedule-send-modal div.menu ul li > span.icon {
  height: 36px;
  margin-right: 12px;
  padding: 20px 0px;
  opacity: .71;
  width: 20px; }

</style>